{
  "pages": {
    "leads": {
      "title": "Leads"
    },
    "leadDetail": {
      "title": "Lead",
      "titleWithId": "Lead #{{id}}",
      "description": "{{status}} · {{source}} · Score {{score}}",
      "loadingDescription": "Lead 360",
      "summary": "Lead Summary",
      "communications": "Communications",
      "activities": "Activities",
      "quotations": "Quotations"
    },
    "deals": {
      "title": "Deals",
      "pipelineBoard": "Pipeline board",
      "loadingKanban": "Loading kanban…",
      "noCustomer": "No customer",
      "noPipelineStages": "No pipeline stages configured.",
      "allDeals": "All deals",
      "createDeal": "Create deal"
    },
    "tasks": {
      "title": "Tasks"
    },
    "followups": {
      "title": "Followups",
      "description": "Calls, meetings, reminders and next actions"
    },
    "campaigns": {
      "title": "CRM campaigns"
    },
    "contacts": {
      "title": "Contacts",
      "editContact": "Edit contact",
      "createContact": "Create contact",
      "possibleDuplicates": "Possible duplicates"
    },
    "companies": {
      "title": "Companies"
    },
    "reports": {
      "title": "CRM Reports"
    },
    "setup": {
      "title": "CRM Setup"
    },
    "customers": {
      "title": "Customer 360",
      "description": "Customer 360 — unified Fattah timeline",
      "loading": "Loading customer profile…"
    },
    "dashboard": {
      "title": "CRM Dashboard",
      "description": "Pipeline, leads, and revenue — filtered to records assigned within your visibility",
      "pipelineDetails": "Pipeline details",
      "openDeals": "Open deals",
      "forecastRevenue": "Forecast revenue",
      "wonRevenue": "Won revenue",
      "conversionRate": "Conversion rate",
      "activitiesDue": "Activities due",
      "totalLeads": "Total leads"
    },
    "segmentedOutreachWithEmailSmsAnd": "Segmented outreach with email, SMS, and WhatsApp channels",
    "b2bAccountsWithContactsDealsAnd": "B2B accounts with contacts, deals, and activities",
    "organizationWideCustomerContactsLinkedTo": "Organization-wide customer contacts linked to Customer 360",
    "pipelineKanbanAndDealListWith": "Pipeline kanban and deal list with finance quote integration",
    "createLead": "Create lead",
    "convertLeadWithId": "Convert lead #{{id}}",
    "manageLeadIntakeQualificationAndConversion": "Manage lead intake, qualification and conversion",
    "noLeadsYet": "No leads yet",
    "captureLeadsFromCampaignsOrAdd": "Capture leads from campaigns or add them manually to start your pipeline.",
    "pipelineConversionLeadSourceAndSalesperson": "Pipeline, conversion, lead source, and salesperson performance",
    "pipelines": "Pipelines",
    "scoringRules": "Scoring rules",
    "assignmentRules": "Assignment rules",
    "workflowAutomations": "Workflow automations",
    "emailAccountsImapSync": "Email accounts (IMAP sync)",
    "pipelinesScoringAssignmentWorkflowsLeadSources": "Pipelines, scoring, assignment, workflows, lead sources, territories, email sync",
    "openCrmTasksAndFollowUps": "Open CRM tasks and follow-ups for your team"
  },
  "common": {
    "yes": "Yes",
    "no": "No",
    "unknownSource": "Unknown source"
  },
  "toast": {
    "leadCreated": "Lead created",
    "leadConverted": "Lead converted — deal created",
    "campaignCreated": "Campaign created",
    "campaignLaunched": "Campaign launched",
    "campaignScheduled": "Campaign scheduled",
    "taskCreated": "Task created",
    "taskCompleted": "Task completed",
    "quoteCreated": "Quote created (invoice #{{invoiceId}})",
    "leadsImported": "Imported {{successCount}} leads",
    "leadsImportedWithFailures": "Imported {{successCount}} leads, {{failureCount}} failed",
    "emailSynced": "Synced {{count}} new email activities",
    "gmailConnected": "Gmail connected via XOAUTH2: {{email}}"
  },
  "errors": {
    "leadCreationFailed": "Lead creation failed",
    "leadConversionFailed": "Lead conversion failed",
    "loadPipelineFailed": "Failed to load pipeline",
    "moveDealFailed": "Move deal failed",
    "createQuoteFailed": "Create quote failed",
    "loadCustomer360Failed": "Failed to load Customer 360",
    "createCampaignFailed": "Failed to create campaign",
    "launchFailed": "Launch failed",
    "scheduleDateRequired": "Pick a schedule date/time first",
    "scheduleFailed": "Schedule failed",
    "createFailed": "Create failed",
    "reportsUnavailable": "Reports unavailable",
    "loadSetupFailed": "Failed to load setup",
    "connectEmailFailed": "Failed to connect email account",
    "emailSyncFailed": "Email sync failed",
    "setupFailed": "Setup failed",
    "googleOAuthNotConfigured": "Google OAuth not configured",
    "loadTasksFailed": "Failed to load tasks",
    "createTaskFailed": "Failed to create task",
    "completeTaskFailed": "Failed to complete task",
    "googleOAuthFailed": "Google OAuth failed: {{error}}",
    "oauthConnectFailed": "OAuth connect failed",
    "failedToLoadCampaigns": "Failed to load campaigns",
    "failedToLoadCompanies": "Failed to load companies",
    "failedToLoadContacts": "Failed to load contacts",
    "failedToLoadDeals": "Failed to load deals",
    "failedToLoadCrmLeads": "Failed to load CRM leads",
    "deleteFailed": "Delete failed",
    "duplicateCheckFailed": "Duplicate check failed",
    "mergeFailed": "Merge failed",
    "leadImportFailed": "Lead import failed",
    "activityCreationFailed": "Activity creation failed",
    "documentCreationFailed": "Document creation failed",
    "communicationRecordingFailed": "Communication recording failed",
    "failedToScheduleReport": "Failed to schedule report"
  },
  "oauth": {
    "connecting": "Connecting Gmail account…"
  },
  "labels": {
    "campaignName": "Campaign name",
    "crm": "CRM",
    "channel": "Channel",
    "audienceSegment": "Audience segment",
    "segment": "Segment",
    "scheduled": "Scheduled",
    "scheduleTimeForRowActionsBelow": "Schedule time (for row actions below)",
    "searchContacts": "Search contacts",
    "searchNameOrEmail": "Search name or email",
    "leadSource": "Lead source",
    "leadStatus": "Lead status",
    "leadScore": "Lead score",
    "leadNumber": "Lead #",
    "leadWithId": "Lead #{{id}}",
    "customerWithId": "Customer #{{id}}",
    "dealWithId": "Deal #{{id}}",
    "source": "Source",
    "score": "Score",
    "converted": "Converted",
    "dealName": "Deal name",
    "deal": "Deal",
    "expectedRevenue": "Expected revenue",
    "revenue": "Revenue",
    "probability": "Probability",
    "proposal": "Proposal",
    "forecast": "Forecast",
    "products": "Products",
    "finance": "Finance",
    "invoiceWithId": "Invoice #{{id}}",
    "customer": "Customer",
    "customerId": "Customer ID",
    "companyId": "Company ID",
    "expectedCloseDate": "Expected close date",
    "proposalStatus": "Proposal status",
    "forecastCategory": "Forecast category",
    "productService": "Product/service",
    "productAmount": "Product amount",
    "budgetConfirmed": "Budget confirmed",
    "decisionMakerNotes": "Decision maker notes",
    "customerName": "Customer name",
    "customerEmail": "Customer email",
    "email": "Email",
    "imapHost": "IMAP host",
    "imapPort": "IMAP port",
    "imapUsername": "IMAP username",
    "imapPassword": "IMAP password",
    "imapPort993": "IMAP port (993)",
    "newTask": "New task",
    "name": "Name",
    "title": "Title",
    "type": "Type",
    "status": "Status",
    "date": "Date",
    "done": "Done",
    "direction": "Direction",
    "subject": "Subject",
    "delivery": "Delivery",
    "quoteNumber": "Quote #",
    "approval": "Approval",
    "total": "Total",
    "expiry": "Expiry",
    "industry": "Industry",
    "phone": "Phone",
    "mobile": "Mobile",
    "jobTitle": "Job title",
    "department": "Department",
    "consent": "Consent",
    "contact": "Contact",
    "primary": "primary",
    "firstName": "First name",
    "lastName": "Last name",
    "whatsapp": "WhatsApp",
    "secondaryPhone": "Secondary phone",
    "preferredLanguage": "Preferred language",
    "consentStatus": "Consent status",
    "emergencyContact": "Emergency contact",
    "emergencyPhone": "Emergency phone",
    "primaryContact": "Primary contact",
    "communicationPreferencesJson": "Communication preferences JSON",
    "socialProfilesJson": "Social profiles JSON",
    "notes": "Notes",
    "assignedEmployee": "Assigned employee",
    "country": "Country",
    "currency": "Currency",
    "actions": "Actions",
    "accountName": "Account name",
    "parentAccountId": "Parent account ID",
    "accountType": "Account type",
    "accountStatus": "Account status",
    "website": "Website",
    "annualRevenue": "Annual revenue",
    "employeeCount": "Employee count",
    "ownership": "Ownership",
    "companySize": "Company size",
    "branchCode": "Branch code",
    "taxNumber": "Tax number",
    "taxRegistrationType": "Tax registration type",
    "language": "Language",
    "timeZone": "Time zone",
    "billingAddress": "Billing address",
    "billingCity": "Billing city",
    "billingState": "Billing state",
    "billingCountry": "Billing country",
    "billingPostalCode": "Billing postal code",
    "shippingAddress": "Shipping address",
    "shippingCity": "Shipping city",
    "shippingState": "Shipping state",
    "shippingCountry": "Shipping country",
    "shippingPostalCode": "Shipping postal code",
    "branchAccount": "Branch account",
    "description": "Description",
    "profile": "Profile",
    "openDeals": "Open deals",
    "openTickets": "Open tickets",
    "activities": "Activities",
    "invoices": "Invoices",
    "quotes": "Quotes",
    "wonRevenue": "Won revenue",
    "searchTimeline": "Search timeline",
    "activityType": "Activity type",
    "newActivity": "New activity",
    "timeline": "Timeline",
    "slaDue": "SLA due {{date}}",
    "financeQuotes": "Finance — Quotes",
    "financeInvoices": "Finance — Invoices",
    "deskTickets": "Desk tickets",
    "closedStatus": "(closed)",
    "openStatus": "(open)",
    "contacts": "Contacts",
    "primaryStatus": "(primary)",
    "deals": "Deals",
    "crmDocuments": "CRM Documents",
    "fileId": "File ID",
    "communicationCenter": "Communication Center",
    "message": "Message"
  },
  "formActions": {
    "convertToDeal": "Convert to deal",
    "convert": "Convert",
    "importCsv": "Import CSV",
    "createCampaign": "Create campaign",
    "launch": "Launch",
    "schedule": "Schedule",
    "addContact": "Add contact",
    "createContact": "Create contact",
    "checkDuplicates": "Check duplicates",
    "mergeCurrentIntoThis": "Merge current into this",
    "addDeal": "Add deal",
    "createDeal": "Create deal",
    "createQuote": "Create quote",
    "submit": "Submit",
    "approve": "Approve",
    "pdf": "PDF",
    "share": "Share",
    "addCompany": "Add company",
    "edit": "Edit",
    "delete": "Delete",
    "createAccount": "Create account",
    "editAccount": "Edit account",
    "saveChanges": "Save changes",
    "addActivity": "Add activity",
    "addDocument": "Add document",
    "record": "Record"
  },
  "listActions": {
    "newLead": "New lead",
    "deleteAccountConfirm": "Delete account {{name}}?",
    "deleteContactConfirm": "Delete contact {{name}}?",
    "openCustomerSupport360": "Open Customer Support 360 →"
  },
  "empty": {
    "noActivitiesYet": "No activities yet",
    "noQuotes": "No quotes",
    "noFinanceInvoices": "No finance invoices",
    "noTickets": "No tickets",
    "noContacts": "No contacts",
    "noDeals": "No deals",
    "noCrmDocuments": "No CRM documents",
    "noSubject": "No subject",
    "noCommunications": "No communications"
  },
  "segments": {
    "allCustomers": "All customers",
    "webFormLeads": "Web form leads",
    "facebookInboxLeads": "Facebook inbox leads"
  },
  "defaults": {
    "dealFromLead": "Deal from lead #{{id}}"
  }
}
